import { IDocumentType } from "store/lobby/lobby-model";

export const isCpfDocumentType = (documentType?: IDocumentType) => documentType === IDocumentType.IdentificationDocument || documentType === IDocumentType.CpfRequired;

export const isDriverLicenseDocumentType = (documentType?: IDocumentType) => documentType === IDocumentType.DriverLicense || documentType === IDocumentType.CnhRequired;

export const isRequiredDocumentType = (documentType?: IDocumentType) => documentType === IDocumentType.CpfRequired || documentType === IDocumentType.CnhRequired;

export const resolveDocumentType = (isDriverLicense: boolean, isRequired: boolean): IDocumentType => {
  if (isDriverLicense && isRequired) return IDocumentType.CnhRequired;
  if (isDriverLicense) return IDocumentType.DriverLicense;
  if (isRequired) return IDocumentType.CpfRequired;
  return IDocumentType.IdentificationDocument;
};
